import { pluralize } from "shared/utils/helpers";

import { LabeledValue } from "./CaseAdminFilters.contracts";
import { QueryFilter as QueryFilterGroup } from "../types/adminTypes";

export const reduceQueriesToApi = (filters: QueryFilterGroup) => {
  // `dataEntry` can only be false if it accompanies a true `reviewed` value.
  if (filters?.dataEntry === false && filters?.reviewed !== true) {
    delete filters.dataEntry;
  }

  return Object.keys(filters).reduce(
    (acc: QueryFilterGroup, filter: string) => {
      if (
        (filter === "isManuallyAccessioned" ||
          filter === "dataEntry" ||
          filter === "billingEntry") &&
        (filters as any)[filter] !== undefined
      ) {
        (acc as any)[filter] = (filters as any)[filter];
      } else if ((filters as any)[filter]) {
        (acc as any)[filter] = !(
          filter === "reviewed" || filter === "hasFinalizingSignature"
        );
      }
      return acc;
    },
    {} as QueryFilterGroup
  );
};

export const matchCert = (candidate?: string) =>
  candidate?.match(/,(\d*)$/)?.[1] || undefined;
// Local helper: parse "true"/"false" to boolean or undefined

export const parseBoolean = (text?: string | null) => {
  if (!text) return undefined;
  if (!["true", "false"].includes(text)) return undefined;
  return text === "true";
};
export const isLabeledValueArray = (input: unknown): input is LabeledValue[] =>
  Array.isArray(input) &&
  input.every(
    (i) => typeof i?.value === "string" && typeof i?.label === "string"
  );
export const getCompleteFilterLabel = (label: string, filterCount: number) =>
  !!filterCount
    ? `${label} (${filterCount} active ${pluralize("filter", filterCount)})`
    : label;
